import { useState } from 'react';
import Layout from 'components/Layout';
import { Route, Routes } from 'react-router-dom';
import GetStartedPage from './page/GetStartedPage';
import Email from './page/Email';
import {
  EmailContext,
  EmailContextType,
  FormStateType,
} from './EmailGeneratorContext';
import { Apps } from 'constants/global';
import Questions from 'features/bot-builder/components/Common/Questions';

const EmailGenerator = () => {
  const [emailContent, setEmailContent] = useState<string[] | null>(null);
  const [isGenerating, setIsGenerating] = useState<boolean>(false);
  const [formState, setFormState] = useState<FormStateType>({
    tone: '',
    type: '',
    prompt: '',
    drafts: 1,
    language: '',
  });

  const [activeIndex, setActiveIndex] = useState(0); // for the active index of draft being edited
  const [isPanelOpen, setIsPanelOpen] = useState<boolean>(false); // for tracking if edit panel is open

  // Function to update email content
  const updateEmailContent = (data: string[]) => {
    setEmailContent(data);
  };

  const updateEmailAtIndex = (index: number, newContent: string) => {
    setEmailContent((prevContent) => {
      if (!prevContent) return null;
      const tempContent = [...prevContent];
      tempContent[index] = newContent;

      return tempContent;
    });
  };

  const emailContextValue: EmailContextType = {
    emailContent,
    isGenerating,
    setIsGenerating,
    updateEmailContent,
    updateEmailAtIndex,
    setFormState,
    formState,
    setActiveIndex,
    activeIndex,
    isPanelOpen,
    setIsPanelOpen,
  };

  return (
    <EmailContext.Provider value={emailContextValue}>
      <Layout>
        <Routes>
          <Route
            path="/get-started"
            element={
              <>
                <GetStartedPage />
                <Questions appType={Apps.EMAIL_GENERATOR} />
              </>
            }
          />
          <Route path="/email" element={<Email />} />
        </Routes>
      </Layout>
    </EmailContext.Provider>
  );
};

export default EmailGenerator;
